import { z } from 'zod';

/** Fleet reference data: the vocabulary a deployment's trucks, trailers and documents are described with (gitaumoses4/chukua#10). */

export const truckClassInputSchema = z.object({
  code: z.string().trim().min(1).max(32),
  name: z.string().trim().min(1).max(120),
  typicalCapacityTonnes: z.number().positive(),
});
export type TruckClassInput = z.infer<typeof truckClassInputSchema>;

export const trailerTypeInputSchema = z.object({
  code: z.string().trim().min(1).max(32),
  name: z.string().trim().min(1).max(120),
});
export type TrailerTypeInput = z.infer<typeof trailerTypeInputSchema>;

export const DOCUMENT_TYPE_APPLIES_TO = ['truck', 'trailer', 'driver'] as const;
export type DocumentTypeAppliesTo = (typeof DOCUMENT_TYPE_APPLIES_TO)[number];

export const documentTypeInputSchema = z.object({
  code: z.string().trim().min(1).max(32),
  name: z.string().trim().min(1).max(120),
  appliesTo: z.enum(DOCUMENT_TYPE_APPLIES_TO),
  legalHardBlock: z.boolean(),
  crossBorderOnly: z.boolean(),
  typicalValidityDays: z.number().int().positive(),
  reminderLeadDays: z.number().int().positive(),
});
export type DocumentTypeInput = z.infer<typeof documentTypeInputSchema>;
